import React from 'react';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';
import PropTypes from 'prop-types';
import { recordEvent } from '@department-of-veterans-affairs/platform-monitoring/exports';
import {
  HAMBURGER_MENU_LINKS,
  HAMBURGER_MENU_LINKS_UPDATED,
} from '../../../utilities/constants';
import HamburgerMenuSection from './HamburgerMenuSection';
import ToggleWrapper from '../ToggleWrapper';

const HamburgerMenuLinks = closeMenu => {
  const isAuthorized = localStorage.getItem('userAuthorized');

  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const isClaimantDetailsUpdateEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalCdUpdateMain,
  );
  const hamburgerMenuContent = isClaimantDetailsUpdateEnabled
    ? HAMBURGER_MENU_LINKS_UPDATED
    : HAMBURGER_MENU_LINKS;

  const handleClick = e => {
    closeMenu();
    recordEvent({
      // prettier-ignore
      'event': e.target.dataset.eventname,
      // prettier-ignore
      'custom_string_2': e.target.innerText || e.target.alt,
      'link-destination': e.target.href || e.target.baseURI,
      'link-origin': 'navigation',
    });
  };

  return (
    <>
      {hamburgerMenuContent.map((item, index) => {
        return (
          <ToggleWrapper
            toggleKey={item.FEATURE_FLAG_NAME}
            displayWhenDisabled={item.DISPLAY_WHEN_DISABLED}
            key={`hamburger-section-${index}`}
          >
            <li
              className={
                isAuthorized === 'false'
                  ? 'vads-u-display--none'
                  : 'is--authorized'
              }
            >
              {'LINKS' in item ? (
                <HamburgerMenuSection
                  section={item}
                  handleClick={handleClick}
                />
              ) : (
                <a
                  href={item.URL}
                  onClick={handleClick}
                  className="nav__mobile-menu-links"
                  data-testid={item.TEST_ID}
                  data-eventname="nav-link-click"
                >
                  {item.LABEL}
                </a>
              )}
            </li>
          </ToggleWrapper>
        );
      })}
      <li>
        <a
          href="/representative/help"
          onClick={handleClick}
          className="nav__mobile-menu-links"
          data-testid="user-nav-help-link"
          data-eventname="nav-link-click"
        >
          Help
        </a>
      </li>
    </>
  );
};

HamburgerMenuLinks.propTypes = {
  closeMenu: PropTypes.func,
};

export default HamburgerMenuLinks;
